import { c as _c } from "react/compiler-runtime";
import { useFormikContext } from 'formik';
import { useState } from 'react';
import Badge from '../base/Badge';
import { StyledCard } from '../base/Card';
import Divider from '../base/Divider';
import Text from '../base/Text';
import Checkbox from '../Form/Fields/Checkbox';
import RadioCardsInput from '../Form/Fields/RadioCardsInput';
import ScrollArea from '../helpers/ScrollArea';
import { Div } from '../helpers/StyledUtils';
import Search from '../Search';
export interface ProjectAccessFormValues {
  project_access: string;
  project_ids: string[];
}
interface ProjectOption {
  id: string;
  name: string;
}
interface Props {
  projects: ProjectOption[];
  current_project_id?: string;
}
const project_access_options = [{
  value: 'all',
  label: 'All projects'
}, {
  value: 'selected',
  label: 'Specific projects'
}];
export function ProjectAccessFields(t0) {
  const $ = _c(16);
  const {
    projects,
    current_project_id
  } = t0;
  const {
    values,
    errors,
    submitCount,
    setFieldValue
  } = useFormikContext();
  const [search, setSearch] = useState("");
  let t1;
  if ($[0] !== current_project_id || $[1] !== errors || $[2] !== projects || $[3] !== search || $[4] !== setFieldValue || $[5] !== submitCount || $[6] !== values.project_access || $[7] !== values.project_ids) {
    const query = search.toLowerCase().trim();
    const matched_projects = query ? projects.filter(project => project.name.toLowerCase().includes(query)) : projects;
    let t2;
    if ($[9] !== current_project_id) {
      t2 = (a, b) => {
        if (a.id === current_project_id) {
          return -1;
        }
        if (b.id === current_project_id) {
          return 1;
        }
        return a.name.localeCompare(b.name);
      };
      $[9] = current_project_id;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    const filtered_projects = [...matched_projects].sort(t2);
    let t3;
    if ($[11] !== setFieldValue || $[12] !== values.project_ids) {
      t3 = project_id => {
        setFieldValue("project_ids", values.project_ids.includes(project_id) ? values.project_ids.filter(id => id !== project_id) : [...values.project_ids, project_id]);
      };
      $[11] = setFieldValue;
      $[12] = values.project_ids;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    const toggleProject = t3;
    let t4;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        direction: "column",
        gap: 3
      };
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Div flex={{
        direction: "column",
        gap: 0
      }}><Text semi={true} size="xs" muted={true} as="label">Project access</Text><RadioCardsInput name="project_access" options={project_access_options} /></Div>;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t1 = <Div flex={t4}>{t5}{values.project_access === "selected" && <><StyledCard overflow_hidden={true}><Search borderless={true} small={true} value={search} onChange={setSearch} placeholder={`Filter ${projects.length} projects...`} /><Divider /><ScrollArea max_h={{
            px: 216
          }} p={1}>{filtered_projects.map(project_0 => <Div key={project_0.id} p={{
              x: 2,
              y: 1.5
            }} flex={{
              align: "center"
            }}><Checkbox name={`project_${project_0.id}`} checked={values.project_ids.includes(project_0.id)} onChange={() => toggleProject(project_0.id)} label={<Div flex={{
                align: "center",
                gap: 2
              }}><Text>{project_0.name}</Text>{project_0.id === current_project_id && <Badge subtle={true} neutral={true}>Current project</Badge>}</Div>} /></Div>)}{filtered_projects.length === 0 && <Div p={{
              x: 3,
              y: 4
            }} flex={{
              justify: "center"
            }}><Text muted={true}>No projects found</Text></Div>}</ScrollArea></StyledCard>{submitCount > 0 && typeof errors.project_ids === "string" && <Text danger={true} size="s">{errors.project_ids}</Text>}</>}</Div>;
    $[0] = current_project_id;
    $[1] = errors;
    $[2] = projects;
    $[3] = search;
    $[4] = setFieldValue;
    $[5] = submitCount;
    $[6] = values.project_access;
    $[7] = values.project_ids;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}